export default __webpack_public_path__ + "static/media/bampowlogo.a497030c.png";